import { CheckIcon } from "@heroicons/react/outline";
import React from "react";

const features = [
  {
    name: "Advanced automation scenarios",
    description:
      "Stand out from crowded inbox with personalized and context based automation emails. Use third-party integrations to give your customers and amazing shopping experience.",
  },
  {
    name: "6+ Marketing Channels",
    description:
      "Provide omni-channel experience to customers by combining Email, SMS and more channels - all on a single platform.",
  },
  {
    name: "Advanced Reporting",
    description:
      "Get actionable insights of where exactly you are loosing the customers across your entire sales funnel.",
  },
  {
    name: "Product Redommendations",
    description:
      "Increase your revenue by suggesting more recommended products based on your customers' purschase history.",
  },
  {
    name: "Next level personalization",
    description:
      "Drive brand loyalty and increase customer engagement with well-timed, relevant, personal and contextual messages.",
  },
  {
    name: "Behavioural Segmentation",
    description:
      "Group customes based on their persona and past behaviour to maximise your marketing ROI.",
  },
  {
    name: "Rich Customer Data",
    description:
      "Growlytics gathers all of the information about your customers and subscribers in a single view with all their activity history.",
  },
  {
    name: "Advanced Platform Integrations",
    description:
      "Integrate third-party platforms like chat/support, shipping etc platform and run automation on top of it.",
  },
];

export default function Example(props) {
  return (
    <div className={props.bg}>
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
        <div>
          <h2 className="text-base font-semibold text-primary-600 uppercase tracking-wide">
            All-in-one platform with
          </h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900">
            Enterprise Capablities
          </p>
          <p className="mt-4 text-lg text-gray-500">
            Equiped with enterprise marketing fetures, Growlytics provides right
            tools, technology, and guidance to grow faster.
          </p>
        </div>
        <div className="mt-12 lg:mt-0 lg:col-span-2">
          <dl className="space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-4 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <CheckIcon
                    className="absolute h-6 w-6 text-green-500"
                    aria-hidden="true"
                  />
                  <p className="ml-9 text-lg leading-6 font-medium text-gray-900">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-9 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
